export default __webpack_public_path__ + "static/media/video-bg.3dcdd934.jpg";